"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Convert camelCase string into dash-case
 * @param camel String to be converted
 */
function decamelize(camel) {
    return camel
        .replace(/([a-z\d])([A-Z])/g, '$1-$2')
        .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1-$2')
        .toLowerCase();
}
exports.decamelize = decamelize;
